import React from "react";
import { IconProps } from "./IconProps";

const ArrowCircleLeftIcon: React.FC<IconProps> = ({
  size,
  thickness,
  ariaLabel,
  color = "currentColor",
}) => {
  switch (`${size}${thickness}`) {
    case "32Light":
      return (
        <svg
          aria-label={ariaLabel}
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill={color}
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M16 3.25C13.4783 3.25 11.0132 3.99777 8.91648 5.39876C6.81976 6.79975 5.18556 8.79103 4.22054 11.1208C3.25552 13.4505 3.00303 16.0141 3.49499 18.4874C3.98696 20.9607 5.20127 23.2325 6.98439 25.0156C8.76751 26.7987 11.0393 28.0131 13.5126 28.505C15.9859 28.997 18.5495 28.7445 20.8792 27.7795C23.209 26.8144 25.2003 25.1802 26.6012 23.0835C28.0022 20.9868 28.75 18.5217 28.75 16C28.746 12.6197 27.4015 9.379 25.0112 6.98877C22.621 4.59854 19.3803 3.25397 16 3.25ZM16 27.25C13.775 27.25 11.5999 26.5902 9.74984 25.354C7.89979 24.1179 6.45785 22.3609 5.60636 20.3052C4.75488 18.2495 4.53209 15.9875 4.96617 13.8052C5.40025 11.6229 6.47171 9.61839 8.04505 8.04505C9.6184 6.47171 11.623 5.40025 13.8052 4.96617C15.9875 4.53208 18.2495 4.75487 20.3052 5.60636C22.3609 6.45784 24.1179 7.89978 25.354 9.74984C26.5902 11.5999 27.25 13.775 27.25 16C27.2467 18.9827 26.0604 21.8422 23.9513 23.9513C21.8422 26.0604 18.9827 27.2467 16 27.25ZM21.75 16C21.75 16.1989 21.671 16.3897 21.5303 16.5303C21.3897 16.671 21.1989 16.75 21 16.75H12.8113L15.53 19.47C15.6037 19.5387 15.6628 19.6215 15.7038 19.7135C15.7448 19.8055 15.7668 19.9048 15.7686 20.0055C15.7704 20.1062 15.7518 20.2062 15.7141 20.2996C15.6764 20.393 15.6203 20.4778 15.549 20.549C15.4778 20.6203 15.393 20.6764 15.2996 20.7141C15.2062 20.7518 15.1062 20.7704 15.0055 20.7686C14.9048 20.7668 14.8055 20.7448 14.7135 20.7038C14.6215 20.6628 14.5387 20.6037 14.47 20.53L10.47 16.53C10.3296 16.3894 10.2507 16.1988 10.2507 16C10.2507 15.8012 10.3296 15.6106 10.47 15.47L14.47 11.47C14.6122 11.3375 14.8002 11.2654 14.9945 11.2688C15.1888 11.2723 15.3742 11.351 15.5116 11.4884C15.649 11.6258 15.7278 11.8112 15.7312 12.0055C15.7346 12.1998 15.6625 12.3878 15.53 12.53L12.8113 15.25H21C21.1989 15.25 21.3897 15.329 21.5303 15.4697C21.671 15.6103 21.75 15.8011 21.75 16Z"
            fill={color}
          />
        </svg>
      );
    default:
      return null;
  }
};

export default ArrowCircleLeftIcon;
